var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto",on:{"click":_vm.openUrl}},[_c('v-img',{staticClass:"white--text align-end",attrs:{"src":_vm.getImage(_vm.photo)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }